import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';

import { AlertService } from '../alert/alert.service';
import { Messages } from '../../model/constants/messages';
import { SpinnerService } from '../spinner/spinner.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  count = 0;
  defaultSpinnerInterval = 0.4;
  defaultTimeout = 100;

  constructor(private alertService: AlertService,
              private router: Router,
              private spinner: SpinnerService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = Number(request.headers.get('timeout')) || this.defaultTimeout;
    const spinnerInterval = Number(request.headers.get('spinnerInterval')) || this.defaultSpinnerInterval;

    setTimeout(() => {
      this.count++;
      if (this.count >= 1) {
        this.spinner.startBackendAction();
      }
    }, spinnerInterval * 1000);

    if (!request.headers.has('Content-Type')) {
      request = request.clone({headers: request.headers.set('Content-Type', 'application/json')});
    }

    return next.handle(request).pipe(
        timeout(timeoutValue * 1000),
        catchError((error: HttpErrorResponse) => {
          const data = {
            reason: error && error.error && error.error.reason ?
                error.error.reason : error.message ? error.message : 'Error in your request',
            status: error.status
          };
          console.error('ERROR:', data);
          if (error.status === 403) {
            // Redirect since this is not a recoverable error.
            this.router.navigate(
                ['/error'],
                {queryParams: {message: Messages.NOT_AUTHENTICATED_ERROR}}
            );
          } else {
            // Show the error and stay on the page so the user can try again.
            this.alertService.error(error.message);
          }
          return throwError(error);
        }),
        finalize(() => {
          this.count--;
          if (this.count === 0) {
            this.spinner.endBackendAction();
          }
        })
    );
  }
}
